const SupportIssue = {
  State_0: "SupportIssue.State_0",
  State_1: "SupportIssue.State_1",
  State_2: "SupportIssue.State_2",
  State_HosDinByra: "SupportIssue.State_HosDinByra",
  State_HosKunden: "SupportIssue.State_HosKunden",
  State_StangtForSvar: "SupportIssue.State_StangtForSvar",
  AgencyLockedBanner: "SupportIssue.AgencyLockedBanner",
  NewSupportCase: "SupportIssue.NewSupportCase",
  DashboardHeaderTitle: "SupportIssue.DashboardHeaderTitle",
  DashboardHeaderDescription: "SupportIssue.DashboardHeaderDescription",
  OpenCases: "SupportIssue.OpenCases",
  ClosedCases: "SupportIssue.ClosedCases",
  Case: "SupportIssue.Case",
  OpenHeaderText: "SupportIssue.OpenHeaderText",
  ClosedHeaderText: "SupportIssue.ClosedHeaderText",
  DoAnswerMessage: "SupportIssue.DoAnswerMessage",
  WriteAnAnswerOrMarkAsResolvedMessage: "SupportIssue.WriteAnAnswerOrMarkAsResolvedMessage",
  WillAnswerMessage: "SupportIssue.WillAnswerMessage",
  WriteAdditionalOrMarkAsResolvedMessage: "SupportIssue.WriteAdditionalOrMarkAsResolvedMessage",
  SupportIssueIdMessage: "SupportIssue.SupportIssueIdMessage",
  MarkAsResolved: "SupportIssue.MarkAsResolved",
  MarkAsResolvedMessage: "SupportIssue.MarkAsResolvedMessage",
  MarkAsResolvedSuccessMessage: "SupportIssue.MarkAsResolvedSuccessMessage",
  MarkAsResolvedHelperMessage: "SupportIssue.MarkAsResolvedHelperMessage",
  ClearedSuccessMessage: "SupportIssue.ClearedSuccessMessage",
  CreatedTheCase: "SupportIssue.CreatedTheCase",
  MarkedAsResolved: "SupportIssue.MarkedAsResolved",
  SupportIssueIsResolved: "SupportIssue.SupportIssueIsResolved",
  SupportIssueIsLocked: "SupportIssue.SupportIssueIsLocked",
  SupportIssueReopenMessage: "SupportIssue.SupportIssueReopenMessage",
  SubjectHelpText: "SupportIssue.SubjectHelpText",
  CreateSuccessMessage: "SupportIssue.CreateSuccessMessage",
  FAQHelpTitle: "SupportIssue.FAQHelpTitle",
  FAQHelpItem1Title: "SupportIssue.FAQHelpItem1Title",
  FAQHelpItem1Text: "SupportIssue.FAQHelpItem1Text",
  FAQHelpItem2Title: "SupportIssue.FAQHelpItem2Title",
  FAQHelpItem2Text: "SupportIssue.FAQHelpItem2Text",
  FAQHelpItem3Title: "SupportIssue.FAQHelpItem3Title",
  FAQHelpItem3Text: "SupportIssue.FAQHelpItem3Text",
  FAQFindMore: "SupportIssue.FAQFindMore",
  DaysSinceSentFormatter: "SupportIssue.DaysSinceSentFormatter",
  SearchFilter: "SupportIssue.SearchFilter",
  User: "SupportIssue.User",
  CategoryFieldHeader: "SupportIssue.CategoryFieldHeader",
  RecipientFieldHeader: "SupportIssue.RecipientFieldHeader",
  RecipientOptionAgency: "SupportIssue.RecipientOptionAgency",
  RecipientOptionAgencyFallback: "SupportIssue.RecipientOptionAgencyFallback",
  RecipientOptionWint: "SupportIssue.RecipientOptionWint",
  RecipientOptionCustomer: "SupportIssue.RecipientOptionCustomer",
  RecipientOptionOther: "SupportIssue.RecipientOptionOther",
  RecipientPersonsFieldHeader: "SupportIssue.RecipientPersonsFieldHeader",
  RecipientPersonsPlaceholder: "SupportIssue.RecipientPersonsPlaceholder",
  ForwardSuccessMessage: "SupportIssue.ForwardSuccessMessage",
  InfoFromWint: "SupportIssue.InfoFromWint",
  WaitingForWint: "SupportIssue.WaitingForWint",
  Replied: "SupportIssue.Replied",
  Solved: "SupportIssue.Solved",
  NoMessage: "SupportIssue.NoMessage",
  MarkAsDoneHint: "SupportIssue.MarkAsDoneHint",
  RatingResponseTitlePositive: "SupportIssue.RatingResponseTitlePositive",
  RatingResponseTextPositive: "SupportIssue.RatingResponseTextPositive",
  RatingResponseTitleNegative: "SupportIssue.RatingResponseTitleNegative",
  RatingResponseTextNegative: "SupportIssue.RatingResponseTextNegative",
  RatingResponseTitleNeutral: "SupportIssue.RatingResponseTitleNeutral",
  RatingResponseTextNeutral: "SupportIssue.RatingResponseTextNeutral",
  FAQSupportFlowAskAQuestion: "SupportIssue.FAQSupportFlowAskAQuestion",
  FAQPopperTitle: "SupportIssue.FAQPopperTitle",
  FAQPopperSubtitle: "SupportIssue.FAQPopperSubtitle",
  FAQPopperSubmitTextSubTitle: "SupportIssue.FAQPopperSubmitTextSubTitle",
  FAQPopperSubmitTextLabel: "SupportIssue.FAQPopperSubmitTextLabel",
  FAQCommonQuestions: "SupportIssue.FAQCommonQuestions",
  FAQShowAll: "SupportIssue.FAQShowAll",
  FAQNoResults: "SupportIssue.FAQNoResults",
  FAQNoResultTitle: "SupportIssue.FAQNoResultTitle",
  FAQNoResultBody: "SupportIssue.FAQNoResultBody",
  FAQBrowseFAQ: "SupportIssue.FAQBrowseFAQ",
  FAQErrorTitle: "SupportIssue.FAQErrorTitle",
  FAQErrorBody: "SupportIssue.FAQErrorBody",
  YourTeam: "SupportIssue.YourTeam",
  ContactSupport: "SupportIssue.ContactSupport",
  ContactSupportText: "SupportIssue.ContactSupportText",
  CreateSupportCaseText: "SupportIssue.CreateSupportCaseText",
  SupportCaseAnswerWaitTime: "SupportIssue.SupportCaseAnswerWaitTime",
  UnansweredQuestionText: "SupportIssue.UnansweredQuestionText",
  UnansweredQuestionTextSupportStep: "SupportIssue.UnansweredQuestionTextSupportStep",
  ThisMessageIsReadOnly: "SupportIssue.ThisMessageIsReadOnly",
  RevisorFAQHelpItem1Title: "SupportIssue.RevisorFAQHelpItem1Title",
  RevisorFAQHelpItem2Title: "SupportIssue.RevisorFAQHelpItem2Title",
  RevisorFAQHelpItem3Title: "SupportIssue.RevisorFAQHelpItem3Title",
  ContactUs: "SupportIssue.ContactUs",
  ContactUsText: "SupportIssue.ContactUsText",
  CreateSupportCase: "SupportIssue.CreateSupportCase",
  ViewCases: "SupportIssue.ViewCases",
  ViewAllQuestions: "SupportIssue.ViewAllQuestions",
  AgentAnswerBlocked: "SupportIssue.AgentAnswerBlocked",
  AgentWorkingSend: "SupportIssue.AgentWorkingSend",
  AgentCaseNotSent: "SupportIssue.AgentCaseNotSent",
  AgentWorking5: "SupportIssue.AgentWorking5",
  AgentAskPlaceholder: "SupportIssue.AgentAskPlaceholder",
  AgentAskPromise: "SupportIssue.AgentAskPromise",
  AgentSendToSupport: "SupportIssue.AgentSendToSupport",
  AgentYourQuestion: "SupportIssue.AgentYourQuestion",
  AgentNotSentInfo: "SupportIssue.AgentNotSentInfo",
  AgentSentNotice: "SupportIssue.AgentSentNotice",
  AgentGoToCase: "SupportIssue.AgentGoToCase",
  AgentSkip: "SupportIssue.AgentSkip",
  AgentNoneOfThese: "SupportIssue.AgentNoneOfThese",
  AgentNoneOfTheseHint: "SupportIssue.AgentNoneOfTheseHint",
  AgentNoneOfTheseDetails: "SupportIssue.AgentNoneOfTheseDetails",
  AgentClarifyPlaceholder: "SupportIssue.AgentClarifyPlaceholder",
  AgentWorkingPrepare: "SupportIssue.AgentWorkingPrepare",
  AgentFoundInWint: "SupportIssue.AgentFoundInWint",
  AgentNewQuestion: "SupportIssue.AgentNewQuestion",
  AgentConfirm: "SupportIssue.AgentConfirm",
  AgentCantAnswer: "SupportIssue.AgentCantAnswer",
  AgentSentAlong: "SupportIssue.AgentSentAlong",
  AgentRowConcerns: "SupportIssue.AgentRowConcerns",
  AgentRowTitle: "SupportIssue.AgentRowTitle",
  AgentRowAttachments: "SupportIssue.AgentRowAttachments",
  AgentNotSentYetInfo: "SupportIssue.AgentNotSentYetInfo",
  AgentAttachedLabel: "SupportIssue.AgentAttachedLabel",
  AgentAdditionLabel: "SupportIssue.AgentAdditionLabel",
  AgentCallInstead: "SupportIssue.AgentCallInstead",
  AgentSendLine: "SupportIssue.AgentSendLine",
  AgentWorking1: "SupportIssue.AgentWorking1",
  AgentWorking2: "SupportIssue.AgentWorking2",
  AgentWorking3: "SupportIssue.AgentWorking3",
  AgentWorking4: "SupportIssue.AgentWorking4",
  }
export default SupportIssue;